<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-09 17:32:06
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-08-12 11:23:37
 * @Description: 默认布局，统一接入站点头部与页脚
-->
<template>
  <div class="site-layout">
    <m-header />
    <main class="site-main">
      <slot></slot>
    </main>
    <m-footer />
    <scroll-to-top />
  </div>
</template>

<script setup lang="ts">
  await useArticleCategories()
  await useMediaCategories()
</script>

<style scoped lang="scss">
  .site-layout {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  .site-main {
    flex: 0 0 auto;
  }
</style>
